<template>
  <div class="root-container">
    <van-nav-bar
      v-if="false"
      style="background: #f5f5f5; padding-top: 25px"
      title="天气"
      left-arrow
      @click-left="onLeftClick"
    />
    <div
      v-if="!loading"
      class="weather-wrap"
      :style="{
        backgroundImage:
          'url(' + getWeatherBgByWeather(todayData.dayweather) + ')',
      }"
    >
      <div class="top-wrap">
        <span class="city-name">{{ city }}</span>
        <div class="info">
          <van-icon
            :name="getWeatherIconByWeather(todayData.dayweather)"
          />
          <div class="temp">
            <span>{{ todayData.daytemp }}°</span>
            <span>{{ todayData.dayweather }}</span>
          </div>
          <div v-if="false" class="warning">
            <span v-if="alertData.content.length > 0" class="type-name">{{
              getAlertNameByCode(alertData.content[0].code)
            }}</span>
            <span
              class="aqi-name"
              :style="{
                color: getLevelColor(realtimeData.air_quality.aqi.chn),
              }"
            >{{ realtimeData.air_quality.description.chn }}</span>
          </div>
        </div>
        <span v-if="false" class="tip">{{ popText }}</span>
      </div>
      <div v-if="false" class="line" />
      <div class="bottom-wrap">
        <div v-for="(item, index) in dailyData" :key="index" class="item">
          <span>{{ getDayTitle(index) }}</span>
          <span>{{ item.dayweather }}</span>
          <van-icon :name="getWeatherIconByWeather(item.dayweather)" />
          <span>{{ item.daytemp }}°</span>
          <span v-if="false">良</span>
        </div>
      </div>
    </div>
    <div class="news-wrap">
      <span class="title">安全头条</span>
      <div
        v-for="item in newsDatas"
        :key="item.id"
        class="item"
        @click="onNewsItemClick"
      >
        <span class="title">{{ item.title }}</span>
        <van-image
          :src="item.img"
          radius="8"
          width="110"
          height="55"
        />
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
import { NavBar } from 'vant'
import { getWeather } from '@/api/weather_gaode.js'
export default {
  name: 'Gaode',
  components: {
    [NavBar.name]: NavBar
  },
  data() {
    return {
      loading: true,
      popText: '', // 降水概率说明
      realtimeData: {}, // 实时天气数据
      dailyData: [], // 逐天数据(4天)
      alertData: {}, // 预警数据
      newsDatas: [
        {
          id: 1,
          title: '【特别关注】疫情期间物流配送防护指南',
          img: require('/static/img/weather_news_thumb.png')
        }
      ],
      todayData: {},
      city: '',
      adCode: null
    }
  },
  created() {
    const adCode = util.getUrlKey('adCode') || '370212'
    localStorage.setItem('adCode', adCode)
    this.getWeather()
  },
  methods: {
    // 通用天气
    getWeather() {
      this.loading = true
      getWeather().then((res) => {
        this.loading = false
        const forecast = res.forecasts[0] || {}
        this.city = forecast.city
        this.dailyData = forecast.casts || []
        this.dailyData.pop()
        this.todayData = this.dailyData[0] || {}
      })
    },
    onLeftClick() {
      try {
        hdk.binding.runtime.goBack()
        hdk.binding.runtime.goClose()
      } catch (error) {
        console.log(error)
      }
    },
    getLocation() {
      this.$ckEvent.add('init', function() {
        const token = hdk.binding.storage.getLJToken()
        // alert('token = ' + token)
        hdk.device.getAppLocation(function(status, result) {
          if (status == 'SUCCESS') {
            const adCode = result.adCode
            // alert(adCode)
            localStorage.setItem('adCode', adCode)
          }
        })
      })
    },
    onNewsItemClick() {
      this.$router.push('/news-detail')
    },
    // 天气图标
    getWeatherIconByWeather(weather) {
      let code = 100
      switch (weather) {
        case '晴':
          code = 100
          break
        case '少云':
          code = 102
          break
        case '晴间多云':
          code = 103
          break
        case '多云':
          code = 101
          break
        case '阴':
          code = 104
          break
        case '有风':
          code = 102
          break
        case '平静':
          code = 102
          break
        case '微风':
          code = 102
          break
        case '和风':
          code = 102
          break
        case '清风':
          code = 102
          break
        case '强风':
          code = 102
          break
        case '劲风':
          code = 102
          break
        case '疾风':
          code = 102
          break
        case '大风':
          code = 102
          break
        case '烈风':
          code = 102
          break
        case '风暴':
          code = 102
          break
        case '狂爆风':
          code = 102
          break
        case '飓风':
          code = 102
          break
        case '热带风暴':
          code = 102
          break
        case '霾':
          code = 502
          break
        case '中度霾':
          code = 511
          break
        case '重度霾':
          code = 512
          break
        case '严重霾':
          code = 513
          break
        case '阵雨':
          code = 350
          break
        case '雷阵雨':
          code = 302
          break
        case '雷阵雨并伴有冰雹':
          code = 304
          break
        case '小雨':
          code = 305
          break
        case '中雨':
          code = 306
          break
        case '大雨':
          code = 307
          break
        case '暴雨':
          code = 310
          break
        case '大暴雨':
          code = 311
          break
        case '特大暴雨':
          code = 312
          break
        case '强阵雨':
          code = 301
          break
        case '强雷阵雨':
          code = 303
          break
        case '极端降雨':
          code = 308
          break
        case '毛毛雨/细雨':
          code = 309
          break
        case '雨':
          code = 399
          break
        case '小雨-中雨':
          code = 314
          break
        case '中雨-大雨':
          code = 315
          break
        case '大雨-暴雨':
          code = 316
          break
        case '暴雨-大暴雨':
          code = 317
          break
        case '大暴雨-特大暴雨':
          code = 318
          break
        case '雨雪天气':
          code = 405
          break
        case '雨夹雪':
          code = 404
          break
        case '阵雨夹雪':
          code = 406
          break
        case '冻雨':
          code = 313
          break
        case '雪':
          code = 499
          break
        case '阵雪':
          code = 407
          break
        case '小雪':
          code = 400
          break
        case '中雪':
          code = 401
          break
        case '大雪':
          code = 402
          break
        case '暴雪':
          code = 403
          break
        case '小雪-中雪':
          code = 408
          break
        case '中雪-大雪':
          code = 409
          break
        case '大雪-暴雪':
          code = 410
          break
        case '浮尘':
          code = 504
          break
        case '扬沙':
          code = 503
          break
        case '沙尘暴':
          code = 507
          break
        case '强沙尘暴':
          code = 508
          break
        case '龙卷风':
          code = 102
          break
        case '雾':
          code = 501
          break
        case '浓雾':
          code = 509
          break
        case '强浓雾':
          code = 510
          break
        case '轻雾':
          code = 500
          break
        case '大雾':
          code = 514
          break
        case '特强浓雾':
          code = 515
          break
        case '热':
          code = 900
          break
        case '冷':
          code = 901
          break
      }
      return require(`/static/color-64/${code}.png`)
    },
    // 天气背景图
    getWeatherBgByWeather(weather) {
      let code = 100
      switch (weather) {
        case '晴':
          code = 100
          break
        case '少云':
          code = 102
          break
        case '晴间多云':
          code = 103
          break
        case '多云':
          code = 101
          break
        case '阴':
          code = 104
          break
        case '有风':
          code = 102
          break
        case '平静':
          code = 102
          break
        case '微风':
          code = 102
          break
        case '和风':
          code = 102
          break
        case '清风':
          code = 102
          break
        case '强风':
          code = 102
          break
        case '劲风':
          code = 102
          break
        case '疾风':
          code = 102
          break
        case '大风':
          code = 102
          break
        case '烈风':
          code = 102
          break
        case '风暴':
          code = 102
          break
        case '狂爆风':
          code = 102
          break
        case '飓风':
          code = 102
          break
        case '热带风暴':
          code = 102
          break
        case '霾':
          code = 502
          break
        case '中度霾':
          code = 511
          break
        case '重度霾':
          code = 512
          break
        case '严重霾':
          code = 513
          break
        case '阵雨':
          code = 350
          break
        case '雷阵雨':
          code = 302
          break
        case '雷阵雨并伴有冰雹':
          code = 304
          break
        case '小雨':
          code = 305
          break
        case '中雨':
          code = 306
          break
        case '大雨':
          code = 307
          break
        case '暴雨':
          code = 310
          break
        case '大暴雨':
          code = 311
          break
        case '特大暴雨':
          code = 312
          break
        case '强阵雨':
          code = 301
          break
        case '强雷阵雨':
          code = 303
          break
        case '极端降雨':
          code = 308
          break
        case '毛毛雨/细雨':
          code = 309
          break
        case '雨':
          code = 399
          break
        case '小雨-中雨':
          code = 314
          break
        case '中雨-大雨':
          code = 315
          break
        case '大雨-暴雨':
          code = 316
          break
        case '暴雨-大暴雨':
          code = 317
          break
        case '大暴雨-特大暴雨':
          code = 318
          break
        case '雨雪天气':
          code = 405
          break
        case '雨夹雪':
          code = 404
          break
        case '阵雨夹雪':
          code = 406
          break
        case '冻雨':
          code = 313
          break
        case '雪':
          code = 499
          break
        case '阵雪':
          code = 407
          break
        case '小雪':
          code = 400
          break
        case '中雪':
          code = 401
          break
        case '大雪':
          code = 402
          break
        case '暴雪':
          code = 403
          break
        case '小雪-中雪':
          code = 408
          break
        case '中雪-大雪':
          code = 409
          break
        case '大雪-暴雪':
          code = 410
          break
        case '浮尘':
          code = 504
          break
        case '扬沙':
          code = 503
          break
        case '沙尘暴':
          code = 507
          break
        case '强沙尘暴':
          code = 508
          break
        case '龙卷风':
          code = 102
          break
        case '雾':
          code = 501
          break
        case '浓雾':
          code = 509
          break
        case '强浓雾':
          code = 510
          break
        case '轻雾':
          code = 500
          break
        case '大雾':
          code = 514
          break
        case '特强浓雾':
          code = 515
          break
        case '热':
          code = 900
          break
        case '冷':
          code = 901
          break
      }
      return `https://cdn.heweather.com/img/plugin/190516/bg/view/${code}d.png`
    },
    // 天气图标
    getWeatherIconByWeather(weather) {
      let code = 100
      switch (weather) {
        case '晴':
          code = 100
          break
        case '少云':
          code = 102
          break
        case '晴间多云':
          code = 103
          break
        case '多云':
          code = 101
          break
        case '阴':
          code = 104
          break
        case '有风':
          code = 102
          break
        case '平静':
          code = 102
          break
        case '微风':
          code = 102
          break
        case '和风':
          code = 102
          break
        case '清风':
          code = 102
          break
        case '强风':
          code = 102
          break
        case '劲风':
          code = 102
          break
        case '疾风':
          code = 102
          break
        case '大风':
          code = 102
          break
        case '烈风':
          code = 102
          break
        case '风暴':
          code = 102
          break
        case '狂爆风':
          code = 102
          break
        case '飓风':
          code = 102
          break
        case '热带风暴':
          code = 102
          break
        case '霾':
          code = 502
          break
        case '中度霾':
          code = 511
          break
        case '重度霾':
          code = 512
          break
        case '严重霾':
          code = 513
          break
        case '阵雨':
          code = 350
          break
        case '雷阵雨':
          code = 302
          break
        case '雷阵雨并伴有冰雹':
          code = 304
          break
        case '小雨':
          code = 305
          break
        case '中雨':
          code = 306
          break
        case '大雨':
          code = 307
          break
        case '暴雨':
          code = 310
          break
        case '大暴雨':
          code = 311
          break
        case '特大暴雨':
          code = 312
          break
        case '强阵雨':
          code = 301
          break
        case '强雷阵雨':
          code = 303
          break
        case '极端降雨':
          code = 308
          break
        case '毛毛雨/细雨':
          code = 309
          break
        case '雨':
          code = 399
          break
        case '小雨-中雨':
          code = 314
          break
        case '中雨-大雨':
          code = 315
          break
        case '大雨-暴雨':
          code = 316
          break
        case '暴雨-大暴雨':
          code = 317
          break
        case '大暴雨-特大暴雨':
          code = 318
          break
        case '雨雪天气':
          code = 405
          break
        case '雨夹雪':
          code = 404
          break
        case '阵雨夹雪':
          code = 406
          break
        case '冻雨':
          code = 313
          break
        case '雪':
          code = 499
          break
        case '阵雪':
          code = 407
          break
        case '小雪':
          code = 400
          break
        case '中雪':
          code = 401
          break
        case '大雪':
          code = 402
          break
        case '暴雪':
          code = 403
          break
        case '小雪-中雪':
          code = 408
          break
        case '中雪-大雪':
          code = 409
          break
        case '大雪-暴雪':
          code = 410
          break
        case '浮尘':
          code = 504
          break
        case '扬沙':
          code = 503
          break
        case '沙尘暴':
          code = 507
          break
        case '强沙尘暴':
          code = 508
          break
        case '龙卷风':
          code = 102
          break
        case '雾':
          code = 501
          break
        case '浓雾':
          code = 509
          break
        case '强浓雾':
          code = 510
          break
        case '轻雾':
          code = 500
          break
        case '大雾':
          code = 514
          break
        case '特强浓雾':
          code = 515
          break
        case '热':
          code = 900
          break
        case '冷':
          code = 901
          break
      }
      return require(`/static/color-64/${code}.png`)
    },
    // 预警类型名称
    getAlertNameByCode(code = 'unknow') {
      if (code == 'unknow') {
        return null
      }
      let name
      const type = code.slice(0, 2)
      const level = code.slice(2)
      switch (type) {
        case '01':
          name = '台风'
          break
        case '02':
          name = '暴雨'
          break
        case '03':
          name = '暴雪'
          break
        case '04':
          name = '寒潮'
          break
        case '05':
          name = '大风'
          break
        case '06':
          name = '沙尘暴'
          break
        case '07':
          name = '高温'
          break
        case '08':
          name = '干旱'
          break
        case '09':
          name = '雷电'
          break
        case '10':
          name = '冰雹'
          break
        case '11':
          name = '霜冻'
          break
        case '12':
          name = '大雾'
          break
        case '13':
          name = '霾'
          break
        case '14':
          name = '道路结冰'
          break
        case '15':
          name = '森林火灾'
          break
        case '16':
          name = '雷雨大风'
          break
      }
      switch (level) {
        case '01':
          name += '蓝色'
          break
        case '02':
          name += '黄色'
          break
        case '03':
          name += '橙色'
          break
        case '04':
          name += '红色'
          break
      }
      return `${name}预警`
    },

    // 逐天天气的日期描述
    getDayTitle(index) {
      if (index == 0) {
        return '今天'
      }
      if (index == 1) {
        return '明天'
      }
      if (index == 2) {
        return '后天'
      }
    },
    // 空气质量级别颜色
    getLevelColor(aqi) {
      const aqi_int = parseInt(aqi)
      if (aqi_int <= 50) {
        // 优
        return '#00FF00'
      } else if (aqi_int <= 100) {
        // 良
        return '#FFFF00'
      } else if (aqi_int <= 150) {
        // 轻度污染
        return '#FFA500'
      } else if (aqi_int <= 200) {
        // 中度污染
        return '#FF0000'
      } else if (aqi_int <= 300) {
        // 重度污染
        return '#800080'
      } else {
        // 严重污染
        return '#8B0000'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.root-container {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
}
.weather-wrap {
  display: flex;
  flex-direction: column;
  padding: 8px;
  height: 300px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  span {
    font-size: 14px;
    color: white;
  }
  .top-wrap {
    margin: 0 20px;
    display: flex;
    flex: 1;
    flex-direction: column;
    .city-name {
      color: white;
      font-size: 15px;
      text-align: left;
    }
    .info {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .temp {
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        span:nth-of-type(1) {
          font-size: 20px;
        }
        span:nth-of-type(2) {
          font-size: 14px;
          margin-top: 6px;
        }
      }
      .warning {
        display: flex;
        flex-direction: column;
        margin-left: auto;
        align-items: flex-end;
        .type-name {
          border-radius: 16px;
          background: orange;
          padding: 2px 12px;
        }
        .aqi-name {
          margin-top: 4px;
        }
      }
    }
    .tip {
      margin-top: 20px;
      text-align: left;
    }
  }
  .bottom-wrap {
    display: flex;
    flex: 1;
    margin: 0 20px;
    align-items: center;
    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      span:nth-of-type(1) {
        margin-bottom: 4px;
      }
      span:nth-of-type(2) {
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
  }
  .line {
    height: 1px;
    background: #e1e1e1;
  }
}
.news-wrap {
  background: white;
  margin-top: 30px;
  margin-left: 12px;
  margin-right: 12px;
  border-radius: 8px;
  padding: 8px 16px;
  text-align: left;
  span {
    font-size: 14px;
  }
  .title {
    font-size: 16px;
  }
  .item {
    padding: 12px 0;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f5f5f5;
    .title {
      flex: 1;
      margin-right: 12px;
    }
  }
}
</style>
